<template>
  <MainLayout section="landing">
    <div id="landing" :class="$mq">
      <div id="logo">
        <img src="@/assets/imgs/logo.png" />
      </div>
  
      <div id="trailer">
        <iframe :width="trailer_width" :height="trailer_height" src="https://www.youtube.com/embed/WqEsQixCVAA?si=O2j4WoMwsFZ57gaK" title="YouTube video player" frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen>
        </iframe>
      </div>
  
      <div id="summary">
        <img class="landing_border" src="@/assets/imgs/border.png" />
  
        <div id="summary_container">
          <h1>A journey beyond imagination</h1>
  
          <p>
            From dark brooding woods haunted with spirits to vibrant hot
            deserts which nomads must traverse, <b>The Longest Tale</b> is a
            journey of wonder and imagination.
          </p>
        
          <div id="summary_buttons">
            <a href="https://store.steampowered.com/app/3507360/The_Longest_Tale/"><img id="wishlist_now" src="@/assets/imgs/wishlist-now.png" /></a>
            <a href="https://devnullprod.com/"><img id="playtest1" src="@/assets/imgs/playtesting.png" /></a>
          </div>
        </div>
  
        <img class="landing_border" src="@/assets/imgs/border.png" />
      </div>
  
  
      <div id="copyright" v-if="mq_xs">
        <p>© Copyright 2025</p>
        <p>Dev Null Productions</p>
        <p>All Rights Reserved</p>
      </div>
    </div>
  </MainLayout>
</template>

<script>
  import MainLayout from '@/components/MainLayout'

  export default {
    name: 'Landing',

    components: {
      MainLayout
    },

    computed : {
      trailer_width (){
        if(this.mq_xl)
          return 1200;
        else if(this.mq_lg)
          return 992;
        else if(this.mq_md)
          return 768;
        else if(this.mq_sm)
          return 560;
        else
          return 376;
      },

      trailer_height (){
        if(this.mq_xl)
          return 675;
        else if(this.mq_lg)
          return 522;
        else if(this.mq_md)
          return 425;
        else if(this.mq_sm)
          return 315;
        else
          return 210;
      }
    }
  }
</script>

<style scoped lang="scss">
@import "@/scss/custom.scss";

#landing{
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.landing_border{
  width: 100%;
  height: 2px;
}

#logo{
  margin-top: 30px;
}

#logo img{
  width: 275px;
}

#trailer img{
  width: calc(100vw - 50px);
  max-width: 1600px;
  margin-top: 16px;
  margin-bottom: 16px;
}

#summary{
  width: 50%;
  flex-grow: 1;
}

#landing.xs #summary{
  flex-grow: unset;
}

#landing.md #summary{
  width: 70%;
}

#landing.sm #summary{
  width: 90%;
}

#landing.xs #summary{
  width: unset;
}

#summary_container{
  padding: 15px;
}

#summary h1{
  font-family: Trajan Pro;
  font-size: 2rem;
}

#landing.xs #summary h1{
  font-size: 1.5rem;
}

#summary p{
  font-size: 1.25rem;
  margin: auto;
}

#landing.xs #summary p{
  font-size: 0.9rem;
}

#summary_buttons{
  margin: auto;
  margin-top: 15px;
  display: flex;
  justify-content: center;
  gap: 25px;
}

#landing.xs #summary_buttons{
  flex-direction: column;
  gap: 5px;
}

#summary_buttons #buy_now{
  width: 150px;
}

#landing.xs #summary_buttons #buy_now{
  margin-bottom: 15px;
}

#summary_buttons #playtest1{
  width: 285px;
}
</style>
